// extracted by mini-css-extract-plugin
export default {"container":"G1015t","mobile":"CSitbZ","badge":"tq150I","price":"sYFWza","goesOnSale":"XawWjy","button":"OlIUAO"};